export class Product {
  id:number;
  codigo:string;
  descripcion:string;
  grupo:string;
  codigo_sernapesca:number;
  promedio:number;

  constructor(id,codigo,descripcion,grupo,codigo_sernapesca,promedio){
    this.id = id;
    this.codigo = codigo;
    this.descripcion = descripcion;
    this.grupo = grupo;
    this.codigo_sernapesca = codigo_sernapesca;
    this.promedio = promedio;
  }

/**
 * Crea el formato JSON para el envio a través de HTTP
 * @return JSON a enviar.
 */
  public getJson(){
    let nul1 = '';
    let nul2 = '';
    if(this.descripcion != '' && this.descripcion != null){
      nul1 = `"description":"${this.descripcion}",`;
    }
    if(this.grupo != '' && this.grupo != null){
      nul2 = `"group":"${this.grupo}",`;
    }

    return `{
      "data":{
        "type": "lot",
        "id": "${this.id}",
        "attributes": {
          "id":"${this.id}",
          `+nul1+`
          `+nul2+`
          "code":"${this.codigo}",
          "sp_code_id":"${this.codigo_sernapesca}",
          "average":"${this.promedio}"
        }
      }
    }`;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Product.ts